import { types } from 'mobx-state-tree';

export default types.model('ItemUsageLogs', {
  created_at: types.maybeNull(types.string),
  ip_address: types.maybeNull(types.string),
  user_email: types.maybeNull(types.string)
});
